/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { Input, InputAdornment } from 'tdesign-react';

import { Replace } from '@/components/icon';

import { IQA } from '..';
import styles from './index.module.less';

interface IProps {
  onChange: (value: IQA) => void;
  value: IQA;
  disabled: boolean;
}

const ItemComp: React.FC<IProps> = (props) => {
  const { value, disabled, onChange } = props;

  const [val, setVal] = useState<IQA>({ q: '', a: '' });
  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange1 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      q: val,
    }));
    onChange({ ...value, q: val });
  }, [value, onChange]);

  const handleChange2 = useCallback((val: string) => {
    setVal(pre => ({
      ...pre,
      a: val,
    }));
    onChange({ ...value, a: val });
  }, [value, onChange]);

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <InputAdornment prepend="Q" style={{ width: '100%', borderRadius: 5, overflow: 'hidden' }}>
          <Input value={val?.q} disabled={disabled} onChange={handleChange1} placeholder='用户发言' />
        </InputAdornment>
      </div>
      <Replace />
      <div className={styles.wrapper}>
        <InputAdornment prepend="A" style={{ width: '100%', borderRadius: 5, overflow: 'hidden' }}>
          <Input value={val?.a} disabled={disabled} onChange={handleChange2} placeholder='角色回复' />
        </InputAdornment>
      </div>
    </div>
  );
};

export default ItemComp;
